exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".bg-coclor{background:#edf7ff}.table-pointer thead{cursor:pointer}.td-padding-small td{padding:0}.toDialog:hover{text-decoration:underline;cursor:pointer}.toDialog:hover,.toDialog:hover .dark{color:#13ce66!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-2d5f6118","scoped":false,"hasInlineConfig":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Notification.vue
// module id = 530
// module chunks = 1